import { useEffect, useMemo, useState } from "react";
import {AppBar, MenuItem, Select, Stack, Typography} from "@mui/material";
import DataTable from "react-data-table-component";
import { Circular } from "../../components/Circular/Circular";
import connectTopLine from "../../components/HOC/connectTopLine";
import { makeStyles } from "@mui/styles";
import { toastApiError } from "../../utils/toastApiError";
import {useReferralLink} from "../../hooks/useReferralLink";
import { httpApi } from "../../api/httpApi";

const months = [
  { text: "January", value: "01" },
  { text: "February", value: "02" },
  { text: "March", value: "03" },
  { text: "April", value: "04" },
  { text: "May", value: "05" },
  { text: "June", value: "06" },
  { text: "July", value: "07" },
  { text: "August", value: "08" },
  { text: "September", value: "09" },
  { text: "October", value: "10" },
  { text: "November", value: "11" },
  { text: "December", value: "12" },
];

// FIXME use mui calendar
const years = {
  2020: "2020",
  2021: "2021",
  2022: "2022",
  2023: "2023",
  2024: "2024",
  2025: "2025",
  2026: "2026",
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme?.palette?.background?.paper, // FIXME why is palette not defined?
    margin: "0 -15px",
  },
  appBar: {
    backgroundColor: "#5361f5",
  },
  refCode: {
    padding: "15px",
    marginBottom: "0px",
    textAlign: "center",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  total: {
    padding: "15px",
    marginBottom: "0px",
  },
  select: {
    marginRight: "15px",
    minWidth: "100px",
  },
}));

const columns = [
  { name: "SubAffiliate", selector: (row) => row.subAffiliateEmail, sortable: true, width: 500 },
  { name: "Commission", selector: (row) => row.subAffiliationCommission, sortable: true, width: 200 },
  { name: "FTDs", selector: (row) => row.ftds, sortable: true },
];

const Subaffilation = () => {
  const [loading, setLoading] = useState(false);
  const [mySubs, setMySubs] = useState([]);
  const [link, setLink] = useState({});
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const classes = useStyles();

  useEffect(() => {
    setLoading(true);
    httpApi
        .doGet('/api/v3/reports/subaffiliation/index')
        .then((response) => setLink(response))
        .catch(toastApiError)
        .finally(() => setLoading(false))
  }, []);

  useEffect(() => {
    setLoading(true);
    httpApi
        .doGet(`/api/v3/reports/subaffiliation/all?year=${year}&month=${month}`)
        .then((response) => setMySubs(response.reports))
        .catch(toastApiError)
        .finally(() => setLoading(false))
  }, [month, year]);

  const referralLink = useReferralLink(link.referralCode);

  const getTotalCommission = useMemo(() => {
    return mySubs.reduce((sum, item) => sum + item.subAffiliationCommission, 0).toFixed(2);
  }, [link, mySubs]);

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <Typography variant="h5" gutterBottom className={classes.refCode}>
          Your referral link: <a href={ referralLink }>{ referralLink }</a>
        </Typography>
        <div className={classes.filters}>
          <Select
            labelId="demo-simple-select-label"
            className={classes.select}
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          >
            {months.map((month, index) => (
              <MenuItem key={month.value} value={index + 1}>
                {month.text}
              </MenuItem>
            ))}
          </Select>
          <Select
            labelId="demo-simple-select-label"
            className={classes.select}
            value={year}
            onChange={(e) => setYear(e.target.value)}
          >
            {Object.entries(years).map(([id, year]) => (
              <MenuItem key={id} value={id}>
                {year}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
      <AppBar sx={{ mt: 4 }} position="static" className={classes.appBar}>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="h6" gutterBottom className={classes.total}>
            Your total commission for <b>{months[month - 1].text}</b> <b>{year}</b> is{" "}
            <b>€{getTotalCommission}</b>
          </Typography>
          <Typography variant="h6" gutterBottom className={classes.total}>
            Your Commission Percentage: {link.subAffiliationPercentage && link.subAffiliationPercentage * 100} %
          </Typography>
        </Stack>
      </AppBar>
      <AppBar position="static" className={classes.appBar}>
        <DataTable theme="darkCustom"
          pagination
          data={mySubs}
          columns={columns}
          progressPending={loading}
          progressComponent={<Circular />}
          paginationComponentOptions={{ noRowsPerPage: true }}
        />
      </AppBar>
    </div>
  );
};

export default connectTopLine(false, false, Subaffilation);
